export const RUTA_BASE = process.env.VUE_APP_RUTA_API;
export const RUTA_BASE_SERVIDOR_BACKEND = process.env.VUE_APP_URL_BASE_SERVIDOR_BEACKEND;
export const RUTA_SERVIDOR_BACKEND = process.env.VUE_APP_URL_SERVIDOR_BEACKEND;
export const imgRouteFromBackend = process.env.VUE_APP_URL_BASE;
export const VUE_APP_SHOW_CHARTER = process.env.VUE_APP_SHOW_CHARTER  ;

// Traducción se texto para componente Keen UI Date Picker
export const KeenUiDatePickerCustom = {
  months: {
    full: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    abbreviated: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  },
  days: {
    full: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    abbreviated: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sáb"],
    initials: ["D", "L", "M", "X", "J", "V", "S"],
  },
};

// Cambia el formato de fecha para componente Keen UI Date Picker
export const KeenUiDatePickerCustomFormatDate = (fecha) =>
  fecha.toLocaleDateString();
